import { Link, useLocation } from "react-router-dom";
import { classNames } from "../../utils/appUtils";
import { NavigationItem } from "../../models/appModels";

interface SidebarItemProps {
  item: NavigationItem;
  onClick?: () => void;
}

export const SidebarItem: React.FC<SidebarItemProps> = ({ item, onClick }) => {
  const location = useLocation();
  const hasChildren = item.children ? item.children.length > 0 : false;

  const isActiveLink = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <li data-testid="player-list" key={item.name}>
        <Link
          to={item.href}
          onClick={() => onClick && onClick()}
          className={classNames(
            isActiveLink(item.href)
              ? "bg-gray-50 text-indigo-600 dark:bg-gray-800 dark:text-white"
              : "text-gray-700 hover:bg-gray-50 hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white",
            "group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6"
          )}
        >
          <item.icon
            aria-hidden="true"
            className={classNames(
              isActiveLink(item.href)
                ? "text-indigo-600 dark:text-white"
                : "text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white",
              "h-6 w-6 shrink-0"
            )}
          />
          {item.name}
        </Link>
        {hasChildren  && (
          <ul role="list" className="mx-10 space-y-1">
            {item.children &&
              item.children.map((subItem) => (
                <li key={subItem.name}>
                  <Link
                    to={subItem.href}
                    onClick={() => onClick && onClick()}
                    className={classNames(
                      isActiveLink(subItem.href)
                        ? "bg-gray-50 text-indigo-600 dark:bg-gray-800 dark:text-white"
                        : "text-gray-700 hover:bg-gray-50 hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white",
                      "group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6"
                    )}
                  >
                    <item.icon
                      aria-hidden="true"
                      className={classNames(
                        isActiveLink(subItem.href)
                          ? "text-indigo-600 dark:text-white"
                          : "text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white",
                        "h-6 w-6 shrink-0"
                      )}
                    />
                    {subItem.name}
                  </Link>
                </li>
              ))}
          </ul>
        )}
      </li>
    </>
  );
};
